export const SITE_TITLE = 'B2C Portal | Principal Malaysia'

export enum StatusEnum {
  Unknown = 'unknown',
  PendingOtp = 'pendingOtp',
  LoggedIn = 'loggedIn',
  FundDelisting = 'fundDelisting',
  FundDelistingOtp = 'fundDelistingOtp',
}
